// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Buzy","field":"styles_field__3H0xo","fieldCol":"styles_fieldCol__3uK-d","diffCol":"styles_diffCol__3iZXI","diff":"styles_diff__3dIGk"};